import { Clock, Phone, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const { t, language } = useLanguage();
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-50 via-white to-slate-100 pt-20" data-testid="hero-section">
      {/* Quality Seal - Fixed position top right */}
      <div className="absolute top-24 md:top-28 right-4 md:right-8 lg:right-16 z-10">
        <img 
          src="https://customer-assets.emergentagent.com/job_4c5b4c59-adba-4a3b-bcab-ae105abc8417/artifacts/gepq2wkc_ChatGPT%20Image%2018%20ene%202026%2C%2010_08_06%20p.m..png"
          alt="Professional Service - Quality Integrity Trust"
          className="h-20 md:h-28 lg:h-32 w-auto object-contain"
          style={{ filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))' }}
        />
      </div>

      <div className="w-full px-4 md:px-8 lg:px-16 py-12 md:py-20 lg:py-28">
        <div className="max-w-7xl mx-auto">
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-1000">
            {/* 24/7 Badge */}
            <div className="inline-block mb-6 md:mb-8">
              <div className="flex items-center gap-2 md:gap-3 bg-[#0F172A] text-white px-4 md:px-6 py-2 md:py-3">
                <Clock className="w-4 h-4 md:w-5 md:h-5 text-[#D4AF37]" />
                <span className="text-xs md:text-sm uppercase tracking-widest">{t.hero.badge}</span>
              </div>
            </div>
            
            {/* Main Title */}
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-[#0F172A] mb-4 md:mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="hero-title">
              {t.hero.title}
              <span className="block text-[#D4AF37] mt-1 md:mt-2">{t.hero.titleHighlight}</span>
            </h1>
            
            {/* Description */}
            <p className="text-base md:text-lg lg:text-xl leading-relaxed text-slate-600 mb-8 md:mb-10 max-w-3xl" data-testid="hero-description">
              {t.hero.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-10 md:mb-12">
              <button 
                onClick={() => scrollToSection("citas")}
                className="bg-[#0F172A] text-white hover:bg-[#1E293B] px-6 md:px-10 py-4 md:py-5 text-sm md:text-base uppercase tracking-widest transition-all duration-300 hover:shadow-xl"
                data-testid="hero-schedule-button"
              >
                {t.hero.scheduleButton}
              </button>
              <button 
                onClick={() => scrollToSection("estimado")}
                className="bg-transparent border-2 border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white px-6 md:px-10 py-4 md:py-5 text-sm md:text-base uppercase tracking-widest transition-all duration-300"
                data-testid="hero-estimate-button"
              >
                {t.hero.estimateButton}
              </button>
            </div>

            {/* Contact Info */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 text-slate-700 max-w-2xl">
              <a href="tel:+17576503192" className="flex items-center gap-3 group hover:text-[#D4AF37] transition-colors bg-white p-4 rounded-lg shadow-sm">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#D4AF37] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <Phone className="w-5 h-5 md:w-6 md:h-6 text-white" />
                </div>
                <div>
                  <p className="text-[10px] md:text-xs uppercase tracking-widest text-slate-500">{language === 'en' ? 'Call Now' : 'Llamar Ahora'}</p>
                  <p className="text-base md:text-lg font-bold">(757) 650-3192</p>
                </div>
              </a>
              <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#0F172A] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 md:w-6 md:h-6 text-[#D4AF37]" />
                </div>
                <div>
                  <p className="text-[10px] md:text-xs uppercase tracking-widest text-slate-500">{language === 'en' ? 'Serving' : 'Sirviendo'}</p>
                  <p className="text-sm md:text-base font-semibold">{t.hero.location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;